import React from "react";
import './cardtop.css'
const Card = ({ title, content, image, link, btn }) => {
  return (
    
    <div className="hero-card">
      <div className="image">
        <img src={image} alt="Verification Card" />
      </div>
      <div className="heading">
        <h2>{title}</h2>
      </div>

      <div className="on-hover">
        <div className="heading-on-hover">
          <h2>{title}</h2>
        </div>
        <div className="paragraph">
          <p>{content}</p>
        </div>
        <div className="link">
          <a href={link} target="_blank">{btn}</a>
        </div>
      </div>
    </div>
  );
};

export default Card;
